import './App.css';
import Calculator from './components/Calculator';

function App() {
  return (
    <div className='App'>
      <div className='Calculator'>
        <Calculator/>
      </div>
    </div>
  );
}
export default App;
